import React from 'react';
import { withRouter } from 'react-router-dom';
import env from '@/env';
import Microapp from '@/components/micro-app';
import { getQuery } from '@/common/utils';
import history from '@/history';
import './index.less';

/*****************
 * 品店策略 - 商品策略 - 详情 *
 *****************/
export const GoodsDetailSetExtraHeaderProps = {
  backIcon: false,
  background:
    '#f5fbff url(//img30.360buyimg.com/pop/jfs/t1/94046/35/20488/11573/61d4310eEea40992d/c19a3c48ba28c35c.png) right bottom/325px no-repeat',
  btns: [],
  onBack: () => {
    const activityId = getQuery('activityId');
    history.push(
      `/activity-manage/myCreate/daily-activities-manager/materials/rule-collection?entry=0&activityId=${activityId}&from=acore&hideTab=1&id=${activityId}`
    );
  },
};

const DailyGoodsDetail = withRouter((props) => {
  const { urlHash = '#/flow-field/field-inventory', disable = false } = props;
  const jid = getQuery('jid');
  const name = getQuery('name');

  /* 子策略信息去设置 */
  function onGotoSettingChild({ childStrategyName }) {
    // 后期可拓展监听这个事件
  }

  return (
    <div className="material-goods-strategy-detail-wrapper">
      <div className="detail-body-fa">
        <Microapp
          destory={true}
          data={{
            onGotoSettingChild: onGotoSettingChild,
            disable,
          }}
          name="DailyGoodsDetail"
          /* 详情页链接(http)：http://wareops.man.jd.com/#/flow-field/field-inventory?aid=27432&jid=123442&createdBy=wangjiawei21 */
          /* 详情不可编辑页链接(http)：http://wareops.man.jd.com/#/flow-field/field-inventory-view?aid=27432&jid=123442&createdBy=wangjiawei21 */
          url={`${env.WAREOPS_DOMAIN}/${urlHash}`}
        />
      </div>
    </div>
  );
});

export default DailyGoodsDetail;
